import StockoutRequestorSelect from "./stockoutRequestorSelect.container";

export default StockoutRequestorSelect;
